module.exports = __webpack_public_path__ + "static/img/home_banner_5.aa3b1a3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/home_banner_5.png
// module id = rvUf
// module chunks = 0